<template>
  <div>
    <transition name="slide-fade" appear>
      <b-row>
        <EncabezadoEstudiante/>
        <b-col cols="lg-12">
          <b-card>
            <p class="text-right float-right"><strong>Año Lectivo {{ $store.state.lectivoColegio }} - Periodo Consulta {{ $store.state.periodoConsulta }}</strong></p>
            <h2>Mis Calificaciones</h2>
            <div v-if="$store.state.periodoConsulta">
              <b-table small hover responsive :items="libretaNotas" :fields="titulosLibreta" v-if="$store.state.idGradoUsuario===19 && $store.state.idColegio===22"></b-table>
              <b-table small hover responsive :items="libretaNotasPree" :fields="titulosLibretaPree" v-else-if="$store.state.idGradoUsuario===19 && $store.state.idColegio!=22"></b-table>
              <b-table small hover responsive :items="libretaNotas" :fields="titulosLibreta" v-else></b-table>
              <hr>
              <p class="text-right float-right">Director de Curso: </p>
              <!--<p>Promedio Periodo: {{ promedioPeriodo }}</p>-->
              <p><a class="btn btn-primary" :href="descargaReporte" target="_blank">Descargar Reporte</a></p>
            </div>
            <div v-else>
              <hr>
              <h4 class="mt-4 text-danger">La consulta de calificaciones no está habilitada en el momento.</h4>
            </div>
          </b-card>      
        </b-col>
      </b-row>
    </transition>
  </div>
</template> 

<script>
  import axios from "axios"
  import * as CONFIG from '@/assets/config.js'
  import EncabezadoEstudiante from '@/containers/EncabezadoEstudiante'

  export default {
    name: 'MisTareas',
    components: {
      EncabezadoEstudiante
    },
    data () {
      return {
        asignaturasCurso: [],
        libretaNotas: [],
        libretaNotasPree: [],
        titulosLibreta: [
          { key: 'asignatura', label: 'ASIGNATURAS' },
          { key: 'ih', label: 'IHS' },
          { key: 'fallas', label: 'FALLAS' },
          { key: 'p1', label: 'PER1' },
          { key: 'p2', label: 'PER2' },
          { key: 'p3', label: 'PER3' },
          { key: 'p4', label: 'PER4' },
          { key: 'promedio', label: 'PROMEDIO' }
        ],
        titulosLibretaPree: [
          { key: 'asignatura', label: 'ASIGNATURAS' },
          { key: 'ih', label: 'IHS' },
          { key: 'observaciones', label: 'OBSERVACIONES' }
        ],
        promedioPeriodo: 0,
        descargaReporte: ''
      }
    },
    methods: {
      async cargarAsignaturasCurso() {
        await axios
        .get(CONFIG.ROOT_PATH + "asignaturas/curso/", { params: { idgradosede: this.$store.state.idGradoSedeUsuario, bd: this.$store.state.bdColegio, lectivo: this.$store.state.lectivoColegio }})
          .then(response => {
          if (response.data.error){
              this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
          } else{
              this.asignaturasCurso = response.data.datos
          }
        })
        .catch(err => {
        if (err.message === "Network Error")
          this.mensajeEmergente("danger","Mensaje","Conexión denegada!. Por favor contáctese con el administrador.");
        else
          this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor contáctese con el administrador." + err.message);
        })
        this.cargaNotasPeriodo()
      },
      async cargaNotasPeriodo() {
        if (this.$store.state.periodoConsulta) {
          if (this.$store.state.idGradoUsuario == 19){
            // Preescolar de Manuela Beltran Colegio No. 22
            if (this.$store.state.idColegio == 22) {
              await axios
              .get(CONFIG.ROOT_PATH + "calificaciones/periodo/", { params: { idmatricula: this.$store.state.idMatriculaUsuario, bd: this.$store.state.bdColegio, lectivo: this.$store.state.lectivoColegio, periodo: this.$store.state.periodoConsulta }})
                .then(response => {
                if (response.data.error){
                  this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
                } else{
                  if (response.data.datos != 0){
                    //console.log(JSON.stringify(response.data.datos))
                    let notasAsignatura = {}
                    this.asignaturasCurso.forEach(asignatura => {
                      let p1 = 0, p2 = 0, p3 = 0, p4 = 0, totalNotasAsignatura = 0, totalFallas = 0, promAsignatura = 0
                      let n1 = '-', n2 = '-', n3 = '-', n4 = '-'
                      notasAsignatura = { 
                        asignatura: asignatura.descripcion, ih: asignatura.ih, fallas: 0, p1: '', p2: '', p3: '', p4: '', promedio: 0
                      }
                      response.data.datos.forEach(calificaciones => {
                        let definitivaPeriodo = 0, suma = 0, cont = 0
                        let nivelP = ''
                        if (asignatura.id_asignatura_grado == calificaciones.id_asignatura_grado) {
                          if (calificaciones.n1) { suma += calificaciones.n1; cont++}
                          if (calificaciones.n2) { suma += calificaciones.n2; cont++}
                          if (calificaciones.n3) { suma += calificaciones.n3; cont++}
                          if (calificaciones.n4) { suma += calificaciones.n4; cont++}
                          if (calificaciones.n5) { suma += calificaciones.n5; cont++}
                          if (calificaciones.n6) { suma += calificaciones.n6; cont++}
                          if (calificaciones.n7) { suma += calificaciones.n7; cont++}
                          if (calificaciones.n8) { suma += calificaciones.n8; cont++}
                          if (suma)
                            calificaciones.definitiva = suma / cont
                          if (calificaciones.recuperacion > calificaciones.definitiva) {
                            definitivaPeriodo = calificaciones.recuperacion
                          } else {
                            definitivaPeriodo = calificaciones.definitiva
                          }
                          if (definitivaPeriodo >= 1 && definitivaPeriodo < 3) nivelP = 'BAJO'
                          else if (definitivaPeriodo >= 3 && definitivaPeriodo < 4) nivelP = 'BASICO'
                          else if (definitivaPeriodo >= 4 && definitivaPeriodo < 4.5) nivelP = 'ALTO'
                          else if (definitivaPeriodo >= 4.5 && definitivaPeriodo <= 5) nivelP = 'SUPERIOR'
                          if (calificaciones.periodo == 1) {
                            p1 = definitivaPeriodo
                            n1 = nivelP
                          }
                          if (calificaciones.periodo == 2) {
                            p2 = definitivaPeriodo
                            n2 = nivelP
                          }
                          if (calificaciones.periodo == 3) {
                            p3 = definitivaPeriodo
                            n3 = nivelP
                          }
                          if (calificaciones.periodo == 4) {
                            p4 = definitivaPeriodo
                            n4 = nivelP
                          }
                          totalFallas += calificaciones.fallas
                          //contAsignaturas++
                        }
                      })
                      totalNotasAsignatura = p1 + p2 + p3 + p4
                      if (totalNotasAsignatura) {
                        promAsignatura = totalNotasAsignatura / this.$store.state.periodoConsulta
                      }
                      if (promAsignatura >= 1 && promAsignatura < 3) notasAsignatura.promedio = 'BAJO'
                      else if (promAsignatura >= 3 && promAsignatura < 4) notasAsignatura.promedio = 'BASICO'
                      else if (promAsignatura >= 4 && promAsignatura < 4.5) notasAsignatura.promedio = 'ALTO'
                      else if (promAsignatura >= 4.5 && promAsignatura <= 5) notasAsignatura.promedio = 'SUPERIOR'
                      else notasAsignatura.promedio = '-'
                      if (p1) notasAsignatura.p1 = n1
                      if (p2) notasAsignatura.p2 = n2
                      if (p3) notasAsignatura.p3 = n3
                      if (p4) notasAsignatura.p4 = n4
                      notasAsignatura.fallas = totalFallas
                      this.libretaNotas.push(notasAsignatura)
                    })
                  }
                }
              })
              .catch(err => {
              if (err.message === "Network Error")
                this.mensajeEmergente("danger","Mensaje","Conexión denegada!. Por favor contáctese con el administrador.");
              else
                this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor contáctese con el administrador." + err.message);
              })
            } else {
              await axios
              .get(CONFIG.ROOT_PATH + "calificacionespree/periodo/", { params: { idmatricula: this.$store.state.idMatriculaUsuario, bd: this.$store.state.bdColegio, lectivo: this.$store.state.lectivoColegio, periodo: this.$store.state.periodoConsulta }})
                .then(response => {
                if (response.data.error){
                  this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
                } else{
                  if (response.data.datos != 0){
                    let notasAsignatura = {}
                    this.asignaturasCurso.forEach(asignatura => {
                      response.data.datos.forEach(calificaciones => {
                        if (asignatura.id_asignatura_grado == calificaciones.id_asignatura_grado) {
                          notasAsignatura = { 
                            asignatura: asignatura.descripcion, 
                            ih: asignatura.ih,
                            observaciones: calificaciones.observaciones,
                          }
                          this.libretaNotasPree.push(notasAsignatura)
                        }
                      })
                    })
                  }
                }
              })
              .catch(err => {
              if (err.message === "Network Error")
                this.mensajeEmergente("danger","Mensaje","Conexión denegada!. Por favor contáctese con el administrador.");
              else
                this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor contáctese con el administrador." + err.message);
              })
            }
          } else {
            await axios
            .get(CONFIG.ROOT_PATH + "calificaciones/periodo/", { params: { idmatricula: this.$store.state.idMatriculaUsuario, bd: this.$store.state.bdColegio, lectivo: this.$store.state.lectivoColegio, periodo: this.$store.state.periodoConsulta }})
              .then(response => {
              if (response.data.error){
                this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
              } else{
                if (response.data.datos != 0){
                  //console.log(JSON.stringify(response.data.datos))
                  let notasAsignatura = {}
                  //let contAsignaturas = 0, promedioPeriodo = 0
                  this.asignaturasCurso.forEach(asignatura => {
                    let p1 = 0, p2 = 0, p3 = 0, p4 = 0, totalNotasAsignatura = 0, totalFallas = 0, promAsignatura = 0
                    notasAsignatura = { 
                      asignatura: asignatura.descripcion, ih: asignatura.ih, fallas: 0, p1: '', p2: '', p3: '', p4: '', promedio: 0
                    }
                    response.data.datos.forEach(calificaciones => {
                      let definitivaPeriodo = 0
                      if (asignatura.id_asignatura_grado == calificaciones.id_asignatura_grado) {
                        if (calificaciones.recuperacion > calificaciones.definitiva) {
                          definitivaPeriodo = calificaciones.recuperacion
                        } else {
                          definitivaPeriodo = calificaciones.definitiva
                        }
                        if (calificaciones.periodo == 1) {
                          p1 = definitivaPeriodo
                        }
                        if (calificaciones.periodo == 2) {
                          p2 = definitivaPeriodo
                        }
                        if (calificaciones.periodo == 3) {
                          p3 = definitivaPeriodo
                        }
                        if (calificaciones.periodo == 4) {
                          p4 = definitivaPeriodo
                        }
                        totalFallas += calificaciones.fallas
                        //contAsignaturas++
                      }
                    })
                    totalNotasAsignatura = p1 + p2 + p3 + p4
                    if (totalNotasAsignatura) {
                      promAsignatura = totalNotasAsignatura / this.$store.state.periodoConsulta
                    }
                    notasAsignatura.promedio = promAsignatura.toFixed(1)
                    if (p1) notasAsignatura.p1 = p1.toFixed(1)
                    if (p2) notasAsignatura.p2 = p2.toFixed(1)
                    if (p3) notasAsignatura.p3 = p3.toFixed(1)
                    if (p4) notasAsignatura.p4 = p4.toFixed(1)
                    notasAsignatura.fallas = totalFallas
                    this.libretaNotas.push(notasAsignatura)
                  })
                  /*
                  if (sumaNotasAsignaturas > 0) {
                    promedioPeriodo = Number(sumaNotasAsignaturas / contAsignaturas)
                  } else {
                    promedioPeriodo = 0
                  }
                  this.promedioPeriodo = promedioPeriodo
                  */
                }
              }
            })
            .catch(err => {
            if (err.message === "Network Error")
              this.mensajeEmergente("danger","Mensaje","Conexión denegada!. Por favor contáctese con el administrador.");
            else
              this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor contáctese con el administrador." + err.message);
            })
          }
        }
      },
      validarSesion() {
        if (this.$store.state.idUsuario == '' || this.$store.state.idUsuario == null) {
          this.$router.push("/pages/sesionfinalizada")
        }
        this.descargaReporte = "https://sised.com.co/sised5/admin/imprimir/reportesf/rep-2-descargable.php?idColegio=" + this.$store.state.idColegio +
        "&bdColegio=" + this.$store.state.bdColegio + "&idCurso=" + this.$store.state.idCursoUsuario + "&aLectivo=" + this.$store.state.lectivoColegio +
        "&idMatricula=" + this.$store.state.idMatriculaUsuario + "&nombreCategoria=" + this.$store.state.categoriaColegio + "&nombreColegio=" + this.$store.state.nombreColegio +
        "&daneColegio=" + this.$store.state.daneColegio + "&nitColegio=" + this.$store.state.nitColegio + "&mundepColegio=" + this.$store.state.municipioColegio + " - " + this.$store.state.departamentoColegio
      },
      mensajeEmergente(variante, titulo, contenido) {
        this.$bvToast.toast(contenido, { title: titulo, variant: variante, toaster: "b-toaster-top-center", solid: true, autoHideDelay: 4000, appendToast: false })
      }
    },
    beforeMount() {
      this.validarSesion()
      this.cargarAsignaturasCurso()
    }
  }
</script>
